export default __webpack_public_path__ + "static/TOYOTA PRADO 120-a2cf6e643a8a346a6addfe7da552cf19.jpg";